import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "routenplaner",
  "use": "routenplaner-usage",
  "viewBox": "0 0 512 389.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 389.6\" id=\"routenplaner\"><path d=\"M432.8.1c-6.1.5-10.6 5.9-10.1 12.1.3 3.1 1.8 5.9 4.2 7.8L470 56H108.6c-41.4 0-75.1 33.7-75.1 75.1 0 41.4 33.7 75.1 75.1 75.1h294.9c29.5 0 52.9 23.4 52.9 52.9S433 312 403.5 312H42l43.1-36c4.8-3.8 5.6-10.8 1.8-15.6-2.2-2.8-5.7-4.4-9.2-4.2-2.5.1-4.9 1-6.8 2.6L4.1 314.2c-4.8 3.9-5.4 10.9-1.6 15.7.5.6 1 1.1 1.6 1.6l66.8 55.6c4.8 3.9 11.8 3.3 15.7-1.5 3.9-4.8 3.3-11.8-1.5-15.7L42 334h361.5c41.4 0 75.1-33.7 75.1-75.1s-33.7-75.1-75.1-75.1H108.6c-29.5 0-52.9-23.4-52.9-52.9S79.1 78 108.6 78H470l-43.1 35.8c-4.8 3.9-5.4 11-1.5 15.7 3.9 4.8 11 5.4 15.7 1.5l66.8-55.6c4.8-3.9 5.4-10.9 1.6-15.7-.5-.6-1-1.1-1.6-1.6L441.2 2.7c-2.3-2-5.4-2.9-8.4-2.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/routenplaner.svg
// module id = 297
// module chunks = 6